interface SearchEmptyProps {
  col?: number;
}
function SearchEmpty({ col = 6 }: SearchEmptyProps) {
  return <div className={`search-form__label-wrap bg-pattern col-${col}`} />;
}

export default SearchEmpty;
